<template>
  <div class="parsed-details d-flex flex-column">
    <parsed-detail-item
      v-for="parsedDetailsType in keys.filter((key) =>
        Object.keys(document.parsed_details).includes(key),
      )"
      :key="parsedDetailsType"
      :parsed-details-type="parsedDetailsType"
      :parsed-detail="document.parsed_details[parsedDetailsType]"
    />
  </div>
</template>

<script>
import * as parsedDetailsTypes from '../../constants/parsedDetailsTypes';
import ParsedDetailItem from './ParsedDetailItem';
import * as documentTypes from '../../constants/documentTypes';

export default {
  components: { 'parsed-detail-item': ParsedDetailItem },
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  computed: {
    EIN() {
      return [
        documentTypes.UNKNOWN,
        documentTypes.PAYSLIP,
        documentTypes.TAX_FORM,
        documentTypes.INVOICE,
        documentTypes.BUSINESS_FILING,
        documentTypes.FINANCIAL_STATEMENT,
        documentTypes.BENEFITS_STATEMENT,
        documentTypes.INSURANCE_STATEMENT,
      ].includes(this.document.document_type)
        ? [parsedDetailsTypes.EIN]
        : [];
    },
    keys() {
      return [
        parsedDetailsTypes.NAME,
        parsedDetailsTypes.ADDRESS,
        parsedDetailsTypes.COMPANY,
        parsedDetailsTypes.DATE_OF_BIRTH,
        parsedDetailsTypes.SSN,
        ...this.EIN,
        parsedDetailsTypes.DOCUMENT_DATE,
        parsedDetailsTypes.EXPIRY_DATE,
        parsedDetailsTypes.ACCOUNT_NUMBER,
        parsedDetailsTypes.CURRENCY,
        parsedDetailsTypes.BEGINNING_BALANCE,
        parsedDetailsTypes.ENDING_BALANCE,
      ];
    },
  },
};
</script>

<style scoped lang="scss">
.parsed-details {
  width: 100%;
}
</style>
